import Box from "@mui/material/Box";
export default function AppBackground() {
  return (
    <Box className="fixed w-full h-full flex bg-white dark:bg-layer-950" />
  );
}
